// src/components/CtaDevis.js
import React from "react";

export default function CtaDevis() {
  const subject = "Demande de devis – Maxime H";
  const body = `
Bonjour Maxime,

Je souhaite un devis pour :

- Type : Un Produit / Un Portrait / Un Moment / Un Lieu
- Lieu du shooting :
- Date(s) souhaitée(s) :
- Usage des photos (web, réseaux, print, e-commerce…) :
- Détails utiles (style, ambiance, contraintes horaires…) :

Mes coordonnées :

- Nom / Société :
- Téléphone :
- Site / Instagram :

Merci !
  `.trim();

  const href = `mailto:contact@maximeh.fr?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div className="cta-devis-wrap" role="complementary" aria-label="Appel à l’action">
      <a className="cta-devis-btn" href={href}>
        Demander un devis gratuit
      </a>
    </div>
  );
}